var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.417 20.167H4.583a1.833 1.833 0 0 1-1.833-1.834V5.5c0-1.013.82-1.833 1.833-1.833h1.834V1.833H8.25v1.834h5.5V1.833h1.833v1.834h1.834c1.012 0 1.833.82 1.833 1.833v12.833c0 1.013-.82 1.834-1.833 1.834m-12.834-11v9.166h12.834V9.167zm0-3.667v1.833h12.834V5.5zm11 11H13.75v-1.833h1.833zm-3.666 0h-1.834v-1.833h1.834zm-3.667 0H6.417v-1.833H8.25zm7.333-3.667H13.75V11h1.833zm-3.666 0h-1.834V11h1.834zm-3.667 0H6.417V11H8.25z"
  })));
};
export default SvgCalendar;